import { importAll } from "../helpers";

const joinedReferences = [
  {
    page: 18,
    left: 885,
    right: 1496,
    top: 1816.5,
    bottom: 1890.5,
    name: "1",
    example: {
      youtubeLink: "https://youtube.com/embed/4CCe4_SPgLc?start=0&autoplay=1",
    },
  },
  {
    page: 19,
    left: 1002,
    right: 1574,
    top: 403,
    bottom: 456,
    name: "2",
    example: {
      youtubeLink: "https://youtube.com/embed/OuKzJXQgqhA?start=3&autoplay=1",
    },
  },
  {
    page: 19,
    left: 937,
    right: 1561,
    top: 1060,
    bottom: 1127,
    name: "3",
    example: {
      youtubeLink: "https://youtube.com/embed/w4nnjhHe15U?start=645&autoplay=1",
    },
  },
  {
    page: 19,
    left: 1014,
    right: 1561,
    top: 2025.5,
    bottom: 2079.5,
    name: "4a",
    example: {
      youtubeLink: "https://youtube.com/embed/hl_6lAvMsKE?start=320&autoplay=1",
    },
  },
  {
    page: 20,
    left: 134,
    right: 561,
    top: 85,
    bottom: 130,
    name: "4b",
    example: {
      youtubeLink: "https://youtube.com/embed/hl_6lAvMsKE?start=379&autoplay=1",
    },
  },
  {
    page: 20,
    left: 895,
    right: 1481,
    top: 794,
    bottom: 855,
    name: "5",
    example: {
      youtubeLink:
        "https://youtube.com/embed/VUk3_qTTVg4?start=1154&autoplay=1",
    },
  },
  {
    page: 21,
    left: 904,
    right: 1550,
    top: 1370.5,
    bottom: 1457.5,
    name: "7",
    example: {
      youtubeLink: "https://youtube.com/embed/49dCBsIGsgY?start=8&autoplay=1",
    },
  },
  {
    page: 22,
    left: 829,
    right: 1480,
    top: 118,
    bottom: 188,
    name: "8",
    example: {
      youtubeLink: "https://youtube.com/embed/DMdJLEGrUrg?start=8&autoplay=1",
    },
  },
  {
    page: 22,
    left: 658,
    right: 1490,
    top: 1867.5,
    bottom: 1947.5,
    name: "9",
    example: {
      youtubeLink:
        "https://youtube.com/embed/Fl2ec3dw-c0?start=9069&autoplay=1",
    },
  },

  {
    page: 24,
    left: 1097,
    right: 1489,
    top: 1188,
    bottom: 1261,
    name: "13",
    example: {
      youtubeLink: "https://youtube.com/embed/bmPBTSfCYQk?start=0&autoplay=1",
    },
  },
  {
    page: 24,
    left: 655,
    right: 1482,
    top: 1836.5,
    bottom: 1922.5,
    name: "14",
    example: {
      youtubeLink: "https://youtube.com/embed/Qw49aOXycsA?start=0&autoplay=1",
    },
  },
  {
    page: 25,
    left: 1112,
    right: 1583,
    top: 66,
    bottom: 159,
    name: "15",
    example: {
      youtubeLink:
        "https://youtube.com/embed/wuL7UC2glJM?start=3322&autoplay=1",
    },
  },
  {
    page: 25,
    left: 900,
    right: 1580,
    top: 739,
    bottom: 809,
    name: "16",
    example: {
      youtubeLink: "https://youtube.com/embed/finYYXkdYmA?start=4&autoplay=1",
    },
  },
  {
    page: 26,
    left: 917,
    right: 1479,
    top: 1239,
    bottom: 1311,
    name: "18",
    example: {
      youtubeLink: "https://youtube.com/embed/txChVYmy4BI?start=585&autoplay=1",
    },
  },
  {
    page: 27,
    left: 953,
    right: 1551,
    top: 1167,
    bottom: 1247,
    name: "20",
    example: {
      youtubeLink: "https://youtube.com/embed/3_Eq9H4bSdQ?start=0&autoplay=1",
    },
  },
  {
    page: 28,
    left: 352,
    right: 1491,
    top: 568,
    bottom: 639,
    name: "21",
    example: {
      youtubeLink:
        "https://youtube.com/embed/pAI4-9yc6kA?start=1784&autoplay=1",
    },
  },
  {
    page: 29,
    left: 605,
    right: 1582,
    top: 1168,
    bottom: 1238,
    name: "22",
    example: {
      youtubeLink:
        "https://youtube.com/embed/r9JpKXBw5Z4?start=1227&autoplay=1",
    },
  },
  {
    page: 30,
    left: 828,
    right: 1470,
    top: 1122,
    bottom: 1193,
    name: "23",
    example: {
      youtubeLink: "https://youtube.com/embed/DMdJLEGrUrg?start=53&autoplay=1",
    },
  },
  {
    page: 31,
    left: 1208,
    right: 1566,
    top: 1378.5,
    bottom: 1448.5,
    name: "25",
    example: {
      youtubeLink: "https://youtube.com/embed/IzF_aRcMqrE?start=0&autoplay=1",
    },
  },
  {
    page: 33,
    left: 1095,
    right: 1555,
    top: 722,
    bottom: 809,
    name: "27",
    example: {
      youtubeLink: "https://youtube.com/embed/EsujIKWQpSE?start=8&autoplay=1",
    },
  },
  {
    page: 33,
    left: 1093,
    right: 1565,
    top: 1172,
    bottom: 1257,
    name: "28",
    example: {
      youtubeLink: "https://youtube.com/embed/vmLvpJySb50?start=15&autoplay=1",
    },
  },
  {
    page: 33,
    left: 966,
    right: 1554,
    top: 1831.5,
    bottom: 1916.5,
    name: "29",
    example: {
      youtubeLink: "https://youtube.com/embed/KYm6Oqn0XNg?start=362&autoplay=1",
    },
  },
  {
    page: 34,
    left: 991,
    right: 1494,
    top: 157,
    bottom: 247,
    name: "30",
    example: {
      youtubeLink: "https://youtube.com/embed/uUpQzgyr988?start=8&autoplay=1",
    },
  },
  {
    page: 34,
    left: 960,
    right: 1498,
    top: 823,
    bottom: 885,
    name: "31",
    example: {
      youtubeLink: "https://youtube.com/embed/N2UJXn0fNi4?start=5&autoplay=1",
    },
  },
  {
    page: 34,
    left: 1035,
    right: 1484,
    top: 1626.5,
    bottom: 1701.5,
    name: "32",
    example: {
      youtubeLink: "https://youtube.com/embed/38VShqkukWY?start=255&autoplay=1",
    },
  },
  {
    page: 35,
    left: 868,
    right: 1557,
    top: 64,
    bottom: 160,
    name: "33",
    example: {
      youtubeLink: "https://youtube.com/embed/TbDnlAmMtSE?start=877&autoplay=1",
    },
  },
  {
    page: 35,
    left: 1048,
    right: 1537,
    top: 1028,
    bottom: 1117,
    name: "34",
    example: {
      youtubeLink: "https://youtube.com/embed/9b4Kia9Din0?start=139&autoplay=1",
    },
  },
  {
    page: 36,
    left: 997,
    right: 1516,
    top: 887,
    bottom: 954,
    name: "35",
    example: {
      youtubeLink: "https://youtube.com/embed/XycHubpUZuM?start=0&autoplay=1",
    },
  },
  {
    page: 37,
    left: 913,
    right: 1527,
    top: 290,
    bottom: 366,
    name: "36",
    example: {
      youtubeLink: "https://youtube.com/embed/0eqDzMxQjx0?start=723&autoplay=1",
    },
  },
  {
    page: 37,
    left: 906,
    right: 1523,
    top: 1678.5,
    bottom: 1758.5,
    name: "37",
    example: {
      youtubeLink: "https://youtube.com/embed/VUk3_qTTVg4?start=395&autoplay=1",
    },
  },
  {
    page: 38,
    left: 815,
    right: 1487,
    top: 388,
    bottom: 471,
    name: "38",
    example: {
      youtubeLink: "https://youtube.com/embed/finYYXkdYmA?start=470&autoplay=1",
    },
  },
  {
    page: 38,
    left: 777,
    right: 1483,
    top: 1704.5,
    bottom: 1777.5,
    name: "39",
    example: {
      youtubeLink: "https://youtube.com/embed/g_VE3IQzkko?start=77&autoplay=1",
    },
  },
  {
    page: 40,
    left: 897,
    right: 1463,
    top: 902,
    bottom: 1029,
    name: "41",
    example: {
      youtubeLink: "https://youtube.com/embed/NVBJNe5b73I?start=14&autoplay=1",
    },
  },
  {
    page: 40,
    left: 820,
    right: 1463,
    top: 1681.5,
    bottom: 1775.5,
    name: "42",
    example: {
      youtubeLink: "https://youtube.com/embed/1JYHyZ82skM?start=1&autoplay=1",
    },
  },
  {
    page: 41,
    left: 913,
    right: 1557,
    top: 1144,
    bottom: 1241,
    name: "43",
    example: {
      youtubeLink: "https://youtube.com/embed/pGWDqSrJU4c?start=0&autoplay=1",
    },
  },
  {
    page: 42,
    left: 857,
    right: 1455,
    top: 1353.5,
    bottom: 1478.5,
    name: "44",
    example: {
      youtubeLink: "https://youtube.com/embed/VUk3_qTTVg4?start=322&autoplay=1",
    },
  },
  {
    page: 43,
    left: 833,
    right: 1555,
    top: 180,
    bottom: 289,
    name: "45",
    example: {
      youtubeLink: "https://youtube.com/embed/gAmw8ATln68?start=10&autoplay=1",
    },
  },
  {
    page: 43,
    left: 935,
    right: 1556,
    top: 1223,
    bottom: 1334,
    name: "46",
    example: {
      youtubeLink: "https://youtube.com/embed/txChVYmy4BI?start=0&autoplay=1",
    },
  },
  {
    page: 19,
    left: 646,
    right: 1135,
    top: 840,
    bottom: 890,
    name: "glazunov_6",
    example: {
      youtubeLink: "https://youtube.com/embed/7cEdQhrpwi4?start=2&autoplay=1",
    },
  },
  {
    page: 19,
    left: 689,
    right: 1228,
    top: 791,
    bottom: 837,
    name: "tchaikovsky_4",
    example: {
      youtubeLink: "https://youtube.com/embed/_Xldfaf4NGw?start=0&autoplay=1",
    },
  },
  {
    page: 20,
    left: 691,
    right: 1362,
    top: 318,
    bottom: 358,
    name: "bach_chrom",
    example: {
      youtubeLink: "https://youtube.com/embed/lHTMq-5B9Co?start=0&autoplay=1",
    },
  },
  {
    page: 20,
    left: 140,
    right: 377,
    top: 403,
    bottom: 442,
    name: "chopin_18",
    example: {
      youtubeLink: "https://youtube.com/embed/CQ3HreNp98o?start=4&autoplay=1",
    },
  },
  {
    page: 20,
    left: 138,
    right: 239,
    top: 446,
    bottom: 485,
    name: "https://youtu.be/Fqq2kFyXupo?t=935",
    example: {
      youtubeLink: "https://youtube.com/embed/Fqq2kFyXupo?start=935&autoplay=1",
    },
  },
  {
    page: 20,
    left: 405,
    right: 818,
    top: 438,
    bottom: 479,
    name: "liszt_1",
    example: {
      youtubeLink: "https://youtube.com/embed/AfT5Ypuo7xI?start=189&autoplay=1",
    },
  },
  {
    page: 21,
    left: 218,
    right: 829,
    top: 1281,
    bottom: 1323,
    name: "wtc_a_dur",
    example: {
      youtubeLink: "https://youtube.com/embed/hmRAWa_pTCQ?start=0&autoplay=1",
    },
  },
  {
    page: 22,
    left: 55,
    right: 392,
    top: 1500,
    bottom: 1577,
    name: "tchai_fugue",
    example: {
      youtubeLink:
        "https://youtube.com/embed/PLmz3Lfzpws?start=2388&autoplay=1",
    },
  },
  {
    page: 22,
    left: 304,
    right: 922,
    top: 1820,
    bottom: 1860,
    name: "shost_fugue",
    example: {
      youtubeLink: "https://youtube.com/embed/VYtVYL_jrJs?start=167&autoplay=1",
    },
  },
  {
    page: 22,
    left: 1082,
    right: 1492,
    top: 1780,
    bottom: 1824,
    name: "ludus",
    example: {
      youtubeLink: "https://youtube.com/embed/8o51Z1-unEs?start=285&autoplay=1",
    },
  },
  {
    page: 22,
    left: 935,
    right: 1122,
    top: 1818,
    bottom: 1860,
    name: "schedrin",
    example: {
      youtubeLink: "https://youtube.com/embed/MtTUGzco2Nc?start=32&autoplay=1",
    },
  },
  {
    page: 27,
    left: 508,
    right: 1569,
    top: 55,
    bottom: 164,
    name: "https://youtu.be/MICksKeZoJU?t=1699",
    example: {
      youtubeLink:
        "https://youtube.com/embed/MICksKeZoJU?start=1699&autoplay=1",
    },
  },
  {
    page: 28,
    left: 708,
    right: 1570,
    top: 162,
    bottom: 214,
    name: "beethoven_23",
    example: {
      youtubeLink: "https://youtube.com/embed/txChVYmy4BI?start=944&autoplay=1",
    },
  },
  {
    page: 28,
    left: 1171,
    right: 1546,
    top: 246,
    bottom: 294,
    name: "doppel",
    example: {
      youtubeLink: "https://youtube.com/embed/j24i8-kx8-c?start=0&autoplay=1",
    },
  },
  {
    page: 34,
    left: 758,
    right: 850,
    top: 778,
    bottom: 823,
    name: "chopin_8",
    example: {
      youtubeLink: "https://youtube.com/embed/Op1qBQRJNLM?start=4&autoplay=1",
    },
  },
  {
    page: 34,
    left: 862,
    right: 942,
    top: 777,
    bottom: 885,
    name: "chopin_23",
    example: {
      youtubeLink: "https://youtube.com/embed/5sfgyreCCII?start=0&autoplay=1",
    },
  },
  {
    page: 43,
    left: 330,
    right: 419,
    top: 1853,
    bottom: 1902,
    name: "cho_2",
    example: {
      youtubeLink: "https://youtube.com/embed/z_MwPdr7WXQ?start=0&autoplay=1",
    },
  },
  {
    page: 43,
    left: 428,
    right: 467,
    top: 1852,
    bottom: 1910,
    name: "cho_4",
    example: {
      youtubeLink:
        "https://youtube.com/embed/JKL-r07YD3w?start=1651&autoplay=1",
    },
  },
  {
    page: 43,
    left: 508,
    right: 887,
    top: 1855,
    bottom: 1919,
    name: "cho_fa",
    example: {
      youtubeLink: "https://youtube.com/embed/kDP3QJyun0I?start=0&autoplay=1",
    },
  },
  {
    page: 45,
    left: 769,
    right: 1422,
    top: 864,
    bottom: 939,
    name: "47a",
    example: {
      youtubeLink: "https://youtube.com/embed/YOx710drHnw?start=140&autoplay=1",
    },
  },
  {
    page: 46,
    left: 391,
    right: 807,
    top: 1843,
    bottom: 1901,
    name: "chorale_42",
    example: {
      youtubeLink: "https://youtube.com/embed/WLnOX3zyyVc?start=139&autoplay=1",
    },
  },
];

export default {
  title: "Ю. Тюлин. Учение о музыкальной фактуре и мелодической фигурации",
  layout: "INLINE",
  joinedReferences,
  chapters: [
    {
      title: "Глава 1. Общее представление о музыкальной фактуре",
      from: 1,
      to: 17,
    },
    { title: "Глава 2. Основные виды фактуры", from: 18, to: 43 },
    {
      title: "Глава 3. Усложненные способы фактурного изложения",
      from: 44,
      to: 70,
    },
  ],
  images: importAll(require.context(`../../pages/tyulin`, false, /\.png$/)),
};
